module.exports = __webpack_public_path__ + "static/img/about-img3.d9d490d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/about-img3.png
// module id = FYrh
// module chunks = 0